import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { authGuard } from './core/auth/auth.guard';

export const appRoutes: VexRoutes = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (m) => m.LoginComponent
          )
      },
      {
        path: 'microsoft/callback',
        loadComponent: () =>
          import('./pages/auth/microsoft-callback/microsoft-callback.component').then(
            (m) => m.MicrosoftCallbackComponent
          )
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboards/analytics',
        pathMatch: 'full'
      },
      {
        path: 'dashboards/analytics',
        loadComponent: () =>
          import(
            './pages/dashboards/dashboard-analytics/dashboard-analytics.component'
          ).then((m) => m.DashboardAnalyticsComponent)
      },
      {
        path: 'crm',
        loadChildren: () =>
          import('./pages/crm/crm.routes').then((m) => m.crmRoutes)
      },
      {
        path: 'cartera',
        loadChildren: () => import('./pages/cartera/cartera.routes')
      },
      {
        path: 'disputas',
        loadChildren: () => import('./pages/disputas/disputas.routes')
      },
      {
        path: 'admin',
        loadChildren: () => import('./pages/admin/admin.routes')
      },
      {
        path: 'identityiq',
        loadChildren: () => import('./pages/identityiq/identityiq.routes')
      },
      {
        path: 'consultas',
        loadChildren: () => import('./pages/consultas/consultas.routes')
      },
      {
        path: 'agenda',
        loadChildren: () =>
          import('./pages/agenda/agenda.routes').then((m) => m.agendaRoutes)
      },
      {
        path: 'comunicaciones',
        loadChildren: () =>
          import('./pages/comunicaciones/comunicaciones.routes').then((m) => m.comunicacionesRoutes)
      },
      {
        path: 'bi',
        loadChildren: () => import('./pages/bi/bi.routes')
      },
      {
        path: 'auditor',
        loadChildren: () => import('./pages/auditor/auditor.routes')
      },
      {
        path: 'procesador-pagos',
        loadChildren: () => import('./pages/procesador-pagos/procesador-pagos.routes')
      },
      {
        path: 'opciones',
        loadChildren: () => import('./pages/options/options.routes').then((m) => m.OptionsRoutes)
      },
    ]
  }
];
